import React, { useState } from "react";
import mmclogo from "../../resources/img/mmclogo2.png";
import Spinner from "../spinner/Spinner";
import useMmcService from "../../services/MmcService";
import Login from "../login/Login";
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";
import NavigationBar from "./NavigationBar";
import NavigationBarForTablet from "./NavigationBarForTablet";
import { useMediaQuery } from "react-responsive";
import ReportPrint from "./ReportPrint";

const AppHeader = ({
  manageUserLogin,
  onResetApp,
  loggedIn,
  registerAsPatient,
}) => {
  const { t: t } = useTranslation();
  const { loading } = useMmcService();
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const isTablet = useMediaQuery({ maxWidth: 1024 });

  const handleLogin = (token, role, userId, login) => {
    setShowLoginDialog(false);

    if (token) {
      manageUserLogin(`bearer ${token}`, role, userId, login);
    }
  };

  const handleLoginClick = () => {
    setShowLoginDialog(true);
  };

  const handleLogoutClick = () => {
    onResetApp();
  };

  const View = () => {
    return (
      <>
        <header className="w3-container w3-theme-l3 w3-center ">
          <div className="w3-row w3-padding-small w3-margin-top w3-margin-buttom">
            {registerAsPatient && loggedIn
              ?
              (isTablet
                ?
                (<>
                  <div className="w3-col s4 w3-mobile w3-padding-small">
                    <img src={mmclogo} alt="MMC logo" className="mmc-logo" />
                  </div>
                  <div className="w3-col s8 w3-mobile">
                    <div className="w3-left">
                      <NavigationBarForTablet onResetApp={onResetApp} />
                      <ReportPrint selectedPatient={null}/>
                    </div>
                    <div className="w3-bar w3-right">
                      <button
                        className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-right"
                        onClick={handleLogoutClick}
                      >
                        {t("logout")}
                      </button>
                      <div className="w3-right">
                        <LanguageSwitcher />
                      </div>
                    </div>
                  </div>
                </>)
                :
                (<>
                  <div className="w3-col s2 w3-mobile w3-padding-small">
                    <img src={mmclogo} alt="MMC logo" className="mmc-logo" />
                  </div>
                  <div className="w3-col s7 w3-mobile">
                    <NavigationBar onResetApp={onResetApp} />
                  </div>
                  <div className="w3-col s3 w3-mobile">
                    <div className="w3-bar w3-right">
                      <button
                        className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-right"
                        onClick={handleLogoutClick}
                      >
                        {t("logout")}
                      </button>
                      <div className="w3-right">
                        <LanguageSwitcher />
                      </div>
                    </div>
                  </div>
                </>)
              )
              :
              (<>
                <div className="w3-col s5 w3-mobile"><img src={mmclogo} alt="MMC logo" className="mmc-logo" /></div>
                <div className="w3-col s1 w3-mobile"><div className="w3-container" /></div>
                <div className="w3-col s6 w3-mobile">
                  <div className="w3-bar w3-right">
                    {!loggedIn && (
                      <>
                        <button
                          className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-right"
                          onClick={handleLoginClick}
                        >
                          {t("login")}
                        </button>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://safepolymedac.ics.forth.gr/ac/signup"
                          className="w3-margin-right"
                        >
                          <label className="label-link">{t("sign_up")}</label>
                        </a>
                      </>
                    )}
                    {loggedIn && (
                      <button
                        className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-right"
                        onClick={handleLogoutClick}
                      >
                        {t("logout")}
                      </button>
                    )}
                    <div className="w3-right">
                      <LanguageSwitcher />
                    </div>
                  </div>
                </div>
              </>)
            }
          </div>
        </header>
        <Login showDialog={showLoginDialog} onLogin={handleLogin} />
      </>
    );
  };

  const content = loading ? <Spinner /> : <View />;
  return <div>{content}</div>;
};

export default AppHeader;
